import Vue from 'vue'
import store from './store'
import { setupPurechat } from "@/purechatApi";
setupPurechat();
import router from './router'

import App from './App.vue'

import './styles/main.scss'

//setup interceptor to check login status
import { setupInterceptor } from './interceptor'
setupInterceptor()

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  events: ['change'],
  classes: true, //apply classes to the input
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
});

//setup vue analytics
import VueAnalytics from 'vue-analytics'

// // TODO set this to Google Analytics Code
Vue.use(VueAnalytics, {
  id: 'UA-132485415-1',
  router, //add router for page tracking
  autoTracking: {
    // pageviewOnLoad: false //disable tracking homepage on every page load
    // exception: true, //will track exceptions which occur, could be useful
  },
  ecommerce: { //enable ecommerce tracking
    enabled: true,
    enhanced: true
  }
})

import VueGtm from 'vue-gtm';
Vue.use(VueGtm, {
  id: ["GTM-MWVRPZV"],
  enabled: true,
  debug: false,
  vueRouter: router
})

//use headful to set head content of page
//for title, keywords, description etc
import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

// make v-focus directive
// add v-focus to element to make it focus
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')


//enable smooth scroll on non supporting browsers
// https://caniuse.com/#feat=css-scroll-behavior
import smoothscroll from 'smoothscroll-polyfill';
// kick off the polyfill!
smoothscroll.polyfill();



// let pureChatScript = document.createElement('script');
// pureChatScript.setAttribute("id","pureChatScript")
// pureChatScript.innerHTML = "window.purechatApi = { l: [], t: [], on: function () { this.l.push(arguments); } }; (function () { var done = false; var script = document.createElement('script'); script.async = true; script.type = 'text/javascript'; script.src = 'https://app.purechat.com/VisitorWidget/WidgetScript'; document.getElementsByTagName('HEAD').item(0).appendChild(script); script.onreadystatechange = script.onload = function (e) { if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) { var w = new PCWidget({c: '3cac0077-eb22-44e9-9820-cd969613e737', f: true }); done = true; } }; })();";
// document.body.append(pureChatScript)